/* import __COLOCATED_TEMPLATE__ from './series-exit-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();